import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=297021c0&scoped=true"
import script from "./header.component.vue?vue&type=script&lang=js"
export * from "./header.component.vue?vue&type=script&lang=js"
import style0 from "./header.component.vue?vue&type=style&index=0&id=297021c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297021c0",
  null
  
)

export default component.exports